import * as React from 'react';
import { connect } from 'react-redux';
import { AppStates } from '../../reducers/app';
import { ReflowableContentSettingState } from '../../reducers/ui/reflowableContentSetting';
import { Dispatch, Action } from 'redux';
import {
  SettingTabPanelList,
  SettingTabPanelListRow,
  SettingTabPanelListRowImageTitle,
} from '../common/SettingTabPanelList';
import ToolIconRadioButtonSet from '../common/ToolIconRadioButtonSet';
import SelectableBigRectangleIconButton
from '../common/SelectableIconButton/SelectableBigRectangleIconButton';
import IconButton from '../common/IconButton';
import { DialogType } from '../common/SettingDialogContainer';
import { PreferenceState } from '../../reducers/preference';
import { setColorScheme, ColorScheme } from '../../actions/PreferenceAction';
import SNEColorUserPatternButton from './SNEColorUserPatternButton';

interface ReflowableContentSNEPatternSelectPanelProps extends ReflowableContentSettingState {
  readonly preference: PreferenceState;
  readonly dispatch: Dispatch<Action>;
  readonly setDialogType: (dialogType: DialogType) => void;
}

const largeButtonContainerStyle: React.CSSProperties = {
  width: '130px',
  height: '60px',
  marginTop: '7px',
  marginBottom: '7px',
  marginLeft: '13px',
  marginRight: '13px',
};

const borderStyle: React.CSSProperties = {
  width: '100%',
  height: 2,
  backgroundColor: '#bebebe',
  marginTop: 0,
  marginBottom: 0,
  borderStyle: 'none',
};

const rowStyle: React.CSSProperties = {
  marginTop: '8px',
  marginBottom: '8px',
};

const ReflowableContentSNEPatternSelectPanel: React.SFC<
  ReflowableContentSNEPatternSelectPanelProps
> = React.memo((props) => {
  const { setDialogType, dispatch, preference } = props;

  return (
    <SettingTabPanelList style={{ width: '511px', margin: '0px 64px 0px 61px' }}>
      <SettingTabPanelListRow style={rowStyle}>
        <SettingTabPanelListRowImageTitle imgName="text_preset_pattern"
          imageStyle={{ width: '102px' }}
          containerStyle={{ width: '102px', marginLeft: '36px' }}
        />
        <ToolIconRadioButtonSet style={{ justifyContent: 'center', width: '100%' }}>
          <SelectableBigRectangleIconButton
            title="1"
            containerStyle={largeButtonContainerStyle}
            imagePath="images/setting-popup/sne/btn_bw_color_preset_01"
            active={preference.colorScheme === ColorScheme.Scheme1}
            onClick={() =>  dispatch(setColorScheme(ColorScheme.Scheme1))}
          />
          <SelectableBigRectangleIconButton
            title="2"
            containerStyle={largeButtonContainerStyle}
            imagePath="images/setting-popup/sne/btn_bw_color_preset_02"
            active={preference.colorScheme === ColorScheme.Scheme2}
            onClick={() =>  dispatch(setColorScheme(ColorScheme.Scheme2))}
          />
          <SelectableBigRectangleIconButton
            title="3"
            containerStyle={largeButtonContainerStyle}
            imagePath="images/setting-popup/sne/btn_bw_color_preset_03"
            active={preference.colorScheme === ColorScheme.Scheme3}
            onClick={() =>  dispatch(setColorScheme(ColorScheme.Scheme3))}
          />
          <SelectableBigRectangleIconButton
            title="4"
            containerStyle={largeButtonContainerStyle}
             imagePath="images/setting-popup/sne/btn_bw_color_preset_04"
             active={preference.colorScheme === ColorScheme.Scheme4}
             onClick={() =>  dispatch(setColorScheme(ColorScheme.Scheme4))}
          />
          <SelectableBigRectangleIconButton
            title="5"
            containerStyle={largeButtonContainerStyle}
            imagePath="images/setting-popup/sne/btn_bw_color_preset_05"
            active={preference.colorScheme === ColorScheme.Scheme5}
            onClick={() =>  dispatch(setColorScheme(ColorScheme.Scheme5))}
          />
          <SelectableBigRectangleIconButton
            title="6"
            containerStyle={largeButtonContainerStyle}
            imagePath="images/setting-popup/sne/btn_bw_color_preset_06"
            active={preference.colorScheme === ColorScheme.Scheme6}
            onClick={() =>  dispatch(setColorScheme(ColorScheme.Scheme6))}
          />
        </ToolIconRadioButtonSet>
      </SettingTabPanelListRow>

      <hr style={borderStyle} />

      <SettingTabPanelListRow style={{ ...rowStyle, marginLeft: '0px' }}>
        <SettingTabPanelListRowImageTitle imgName="text_user_setting"
          imageStyle={{ width: '102px' }}
          containerStyle={{ width: '102px', marginLeft: '36px' }}
        />
        <div style={{ display: 'flex', justifyContent:'space-between', width: '100%' }}>
          <div style={{ marginLeft: '32px' }}>
            <SNEColorUserPatternButton
              textColorIndex={preference.customPageColorIndex.textColorIndex}
              backgroundColorIndex={preference.customPageColorIndex.backgroundColorIndex}
              containerStyle={{ ...largeButtonContainerStyle }}
              active={preference.colorScheme === ColorScheme.UserCustomColor}
              onClick={() =>  dispatch(setColorScheme(ColorScheme.UserCustomColor))}
            />
          </div>
          <div style={{ marginRight: '9px', height:'76px', display: 'flex',
            alignItems:'center' }}>
            <IconButton
              title="色選択へ"
              imagePath="images/setting-popup/sne/btn_color_select"
              style={{ width: '100px', height:'44px' }}
              svgStyle={{ width: '100px', height:'44px' }}
              margin={false}
              onClick={ () => { setDialogType(DialogType.ColorSetting); } }
            />
          </div>
        </div>
      </SettingTabPanelListRow>
    </SettingTabPanelList>
  );
});

const mapStateToProps = (appStates: AppStates) => ({
  ...appStates.ui.reflowableContentSetting,
  preference: appStates.preference,
});

export default connect(mapStateToProps)(ReflowableContentSNEPatternSelectPanel);
